import React, { Component } from 'react';
import enhanceWithClickOutside from 'react-click-outside';
import ArrowDown from '../Icons/ArrowDown';
import * as Styled from './styled';

interface IOption {
  value: string | number;
  label: string;
  active?: boolean;
}

interface SelectProps {
  onSelect: (value: any) => void;
  selected: IOption;
  items: IOption[];
}

interface State {
  menuOpen: boolean;
}

class CalendarSelect extends Component<SelectProps, State> {
  constructor(props) {
    super(props);

    this.state = {
      menuOpen: false,
    };
  }

  toggleMenuState = () => {
    this.setState({
      menuOpen: !this.state.menuOpen,
    });
  };

  closeMenu = () => {
    this.setState({
      menuOpen: false,
    });
  };

  handleClickOutside() {
    if (this.state.menuOpen) {
      this.setState({
        menuOpen: false,
      });
    }
  }

  render() {
    const { onSelect, items, selected } = this.props;

    return (
      <Styled.SelectContainer>
        <Styled.SelectValueContainer onClick={this.toggleMenuState}>
          <Styled.SelectValue>{selected.label}</Styled.SelectValue>
          <ArrowDown />
        </Styled.SelectValueContainer>
        {this.state.menuOpen && (
          <Styled.SelectOptions>
            {items.map((item) => {
              const selectOption = () => {
                onSelect(item);
                this.closeMenu();
              };

              return (
                <Styled.SelectOptionItem key={item.value}>
                  <Styled.SelectOption onClick={selectOption} active={item.active}>
                    {item.label}
                  </Styled.SelectOption>
                </Styled.SelectOptionItem>
              );
            })}
          </Styled.SelectOptions>
        )}
      </Styled.SelectContainer>
    );
  }
}

export default enhanceWithClickOutside(CalendarSelect);
